export default () => {
  const cont = document.querySelector(".faq-wrapper");
  
  cont ? hideFaq() : false;

  function hideFaq() {
    const faqs = cont.querySelectorAll(".faq-item");

    faqs.forEach((faq) => {
      const faqTitle = faq.querySelector(".faq-title");

      const faqTitleHeight = faqTitle.offsetHeight;
      if (faq.classList.contains("opened")) {
        faq.style.maxHeight = faqTitleHeight + "px";
      }
      faqTitle.addEventListener("click", () => {
        if (faq.classList.contains("opened")) {
          faq.style.maxHeight = "100em";
          
        } else {
            faq.style.maxHeight = faqTitleHeight + "px";
         
        }
        faq.classList.toggle("opened");
      });
    });
  }
};
